import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["style", "className", "index"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text, border } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Tag } from '@rexlabs/tag';
import { Truncate } from '@rexlabs/text';
import { HoverContainer } from './hover-container';
import { useSelect } from '../hooks/use-select';
var Add = Icons.Add;
var defaultStyles = StyleSheet({
  container: _objectSpread({}, border.styles({
    target: 'select.freeform.container',
    top: {
      width: 'thin',
      color: 'container.static.light'
    }
  })),
  label: _objectSpread(_objectSpread({
    maxWidth: '100%'
  }, text.styles({
    target: 'select.freeform.label',
    fallback: 'normal.default'
  })), {}, {
    gap: function gap(_ref) {
      var token = _ref.token;
      return token('spacing.xs');
    }
  })
});
export var FreeformFixture = /*#__PURE__*/forwardRef(function FreeformFixture(_ref2, ref) {
  var style = _ref2.style,
      className = _ref2.className,
      index = _ref2.index,
      props = _objectWithoutProperties(_ref2, _excluded);

  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      freeform = _useSelect.freeform,
      items = _useSelect.items,
      inputValue = _useSelect.inputValue,
      highlightedIndex = _useSelect.highlightedIndex;

  var _ref3 = freeform !== null && freeform !== void 0 ? freeform : {},
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? 'Add' : _ref3$label;

  var showShiftIcon = highlightedIndex > -1 && highlightedIndex !== items.length;
  return /*#__PURE__*/React.createElement(HoverContainer, _extends({}, props, s.with('container')({
    style: style,
    className: className
  }), {
    ref: ref,
    index: index
  }), /*#__PURE__*/React.createElement(Box, _extends({}, s('label'), {
    flex: 1,
    alignItems: "center"
  }), /*#__PURE__*/React.createElement(Add, {
    size: "m"
  }), label, /*#__PURE__*/React.createElement(Truncate, {
    position: "middle"
  }, "\"".concat(inputValue, "\"")), /*#__PURE__*/React.createElement(Tag, null, "".concat(showShiftIcon ? '⇧' : '', " \u21B5"))));
});